export enum DocumentViewerActionTypes {
  REDACT_DOCUMENT = 'REDACT_DOCUMENT'
}
